import React, { useCallback } from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface ReasonForLoanInputProps {
  // Controlled pattern (used by JourneyPage)
  value?: { reason_for_loan?: string | null };
  onChange?: (val: { reason_for_loan: string }) => void;
  disabled?: boolean;
  // Legacy pattern
  initialData?: { reason_for_loan?: string };
  onDataChange?: (data: { reason_for_loan: string }) => void;
}

const REASON_OPTIONS = [
  { value: 'dayToDayExpenses', label: 'Day to Day Expenses' },
  { value: 'newLocation', label: 'New Location' },
  { value: 'growthCapital', label: 'Growth Capital' }
];

const ReasonForLoanInput: React.FC<ReasonForLoanInputProps> = ({
  value,
  onChange,
  disabled,
  initialData,
  onDataChange,
}) => {
  const currentValue = (value?.reason_for_loan ?? initialData?.reason_for_loan ?? 'growthCapital') || 'growthCapital';

  const handleChange = useCallback((val: string) => {
    onChange?.({ reason_for_loan: val });
    onDataChange?.({ reason_for_loan: val });
  }, [onChange, onDataChange]);

  return (
    <div className="space-y-1.5">
      <Label className="text-gray-500 font-medium">Reason for Loan</Label>
      <Select value={currentValue || undefined} onValueChange={handleChange} disabled={disabled}>
        <SelectTrigger className="border-gray-200 focus:border-intellend-green focus:ring-intellend-green rounded-xl py-6">
          <SelectValue placeholder="Select reason for loan" />
        </SelectTrigger>
        <SelectContent>
          {REASON_OPTIONS.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default ReasonForLoanInput;
